export function isBrowserVisible(): boolean {
    return !document.hidden;
}
